module.exports = __webpack_public_path__ + "images/2i-i62a727a5d22d8fc029df35a5b792ccac.svg";